import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  LittleTiffAskRequestModel,
  LittleTiffAskResponseModel,
  LittleTiffFeedbackRequestModel,
  LittleTiffStatusModel
} from '../../models/littleTiffModel';

@Injectable({
  providedIn: 'root'
})
export class LittleTiffService {

  constructor(private http: HttpClient) {
  }

  getStatus(): Observable<LittleTiffStatusModel> {
    return this.http.get<LittleTiffStatusModel>(`${environment.apiServer.webApiURL}/LittleTiff/Status`);
  }

  ask(request: LittleTiffAskRequestModel): Observable<LittleTiffAskResponseModel> {
    return this.http.post<LittleTiffAskResponseModel>(`${environment.apiServer.webApiURL}/LittleTiff/Ask`, request);
  }

  saveFeedback(request: LittleTiffFeedbackRequestModel): Observable<any> {
    return this.http.post(`${environment.apiServer.webApiURL}/LittleTiff/Feedback`, request);
  }
}
